import {Component, OnInit} from '@angular/core';
import {BaseComponent} from '../shared/components/base.component';
import {ForgotPasswordService} from './forgot-password.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UserPreferencesService} from '../shared/service/user-preferences.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  providers: [ForgotPasswordService]
})
export class ForgotPasswordComponent extends BaseComponent implements OnInit {

  public model: string;
  public isResetPasswordRequestSent: boolean;
  public isProccessing: boolean;
  public logoUrl: string;

  constructor(private forgotPasswordService: ForgotPasswordService, private router: Router, private route: ActivatedRoute,
              private userPreferencesService: UserPreferencesService) {
    super();
  }

  ngOnInit() {
    this.model = '';
    this.isResetPasswordRequestSent = false;
    this.isProccessing = false;
    this.logoUrl = this.userPreferencesService.getCompanyLogoUrl();
  }

  public onSubmit() {
    this.isProccessing = true;
    this.forgotPasswordService.resetPassword(this.model).subscribe(
      () => this.onResetPasswordSuccess(),
      error => this.isProccessing = false,
      () => this.isProccessing = false
    );
  }

  public goBack() {
    this.router.navigate(['login'], {relativeTo: this.route.parent});
  }

  private onResetPasswordSuccess() {
    this.isResetPasswordRequestSent = true;
  }
}
